import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// fake data generator
const getItems = (filename) => {
  const arrayOfObjects = filename.map((item) => ({ id: `item-${item}`, content: `${item}` }));
  return arrayOfObjects;
};

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
// a little function to reduce the items down to just a list for the parent
const reduceObj = (array) => {
  const namesArray = array.reduce((accumulator, currentObject) => {
    accumulator.push(currentObject.content);
    return accumulator;
  }, []);
  return namesArray;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // padding: grid * 2,
  margin: `0 ${grid}px 0 0`,

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : 'grey',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  display: 'flex',
  padding: grid,
  overflow: 'auto',
});

const DragNDrop = (props) => {
  const [items, setItems] = useState(getItems(props.filename));
  const [previousPropValue, setPreviousPropValue] = useState([]);

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const reorderdItems = reorder(items, result.source.index, result.destination.index);

    setItems(reorderdItems);
    const updatedFilenameArray = reduceObj(reorderdItems);
    props.onDataChange(updatedFilenameArray);
  };

  useEffect(() => {
    if (props.filename !== previousPropValue) {
      // Prop has changed, perform action
      // Update state to keep track of the latest prop value
      setPreviousPropValue(props.filename);
      setItems(getItems(props.filename));
    }
  }, [props.filename, previousPropValue]);

  const handleRemoveClick = (e) => {
    e.preventDefault();
    const updatedItems = props.filename.filter((item) => item !== e.target.id);
    props.onDataChange(updatedItems);
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" direction="horizontal">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    >
                      <div className="btn btn-primary active" size="sm">
                        {item.content}
                      </div>
                      <div
                        className="btn btn-primary btn-sm btn-secondary"
                        id={item.content}
                        onClick={(e) => handleRemoveClick(e)}
                      >
                        X
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default DragNDrop;

// Put the thing into the DOM!
// ReactDOM.render(<App />, document.getElementById('root'));
